import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import Link from React Router


export const ViewPicker = ({ onViewValueChanged, viewValue }) => {

  const [selectedView, setSelectedView] = useState(viewValue);
  const [resizeKey, setResizeKey] = useState(0);

  const handleViewChange = (newValue) => {
    // Notify parent iframe before transition starts
    window.parent.postMessage({
      type: 'viewChanging',
      newView: newValue,
      estimatedHeight: newValue === 'Calendar' ? 800 : 2000 // Adjust these values
    }, window.location.origin);

    // Update view state
    setSelectedView(newValue);
    localStorage.setItem('selectedView', newValue);
    onViewValueChanged(newValue);
    triggerResize();

    // Final resize after transition completes
    setTimeout(() => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({
        type: 'viewChanged',
        height: height,
        viewType: newValue
      }, window.location.origin);
    }, 350); // Match your CSS transition duration
  };

  const triggerResize = () => {
    if (typeof window.parentIFrame?.size === "function") {
      setTimeout(() => {
        window.parentIFrame.size();
        console.log("Resize triggered", new Date().toLocaleTimeString());
        setResizeKey((prev) => prev + 1); // Force re-render
      }, 300); // Longer delay for dynamic content
    } else {
      console.warn("parentIFrame not available");
    }
  };

  useEffect(() => {
    console.log("ParentIFrame available?", !!window.parentIFrame);
  }, []);

  return (
    <div className="flex flex-auto items-center place-items-end font-montserrat">
      <p
        className="justify-end"
        id="cFilter"
        style={{
          fontFamily: "Montserrat, sans-serif",
          textTransform: "uppercase",
          fontWeight: "normal",
          fontSize: "14px",
        }}
      >
        CHANGE VIEW:
      </p>
      <div className="" id="cFilter">
        <button
          onClick={() => handleViewChange("List")}
          id="list-button"
          className={`text-white font-bold px-3 py-1 rounded-none`}
          style={{
            fontFamily: "Montserrat, sans-serif",
            textTransform: "uppercase",
            fontWeight: "bold",
            fontSize: "14px",
            color: selectedView === "List" ? "white" : "#009ED0",
          }}
          onContextMenu={(e) => e.preventDefault()} // Disable right-click
        >
          LIST
        </button>
      </div>
      <div id="cFilter">
        <button
          onClick={() => handleViewChange("Calendar")}
          id="cal-button"
          className={`text-white font-bold px-3 py-1 rounded-none`}
          style={{
            fontFamily: "Montserrat, sans-serif",
            textTransform: "uppercase",
            fontWeight: "bold",
            fontSize: "14px",
            color: selectedView === "Calendar" ? "white" : "#009ED0",
            color: selectedView === "List" ? "#009ED0" : "",
          }}
          onContextMenu={(e) => e.preventDefault()} // Disable right-click
        >
          CALENDAR
        </button>
      </div>
    </div>
  );
};